var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"apex-chart-container"},[_c('apexchart',{attrs:{"type":"bar","height":"380","options":_vm.chartOptions,"series":_vm.series}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }